var render = function render(){var _vm=this,_c=_vm._self._c;return _c('data-chip',{attrs:{"text":_vm.eventType.title,"iconLeft":_vm.eventType.icon,"color":_vm.eventType.color,"small":_vm.small}})
}
var staticRenderFns = []

export { render, staticRenderFns }